/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  select-account-api.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date        : 05 Nov 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali - H175591
 * On            : 05 Nov 2019
 * Description   : ASDS-1318
 *
 * By            : Deepthi Bachu - E844276
 * On            : 11 Feb, 2020
 * Description   : ASDS-2197 - Select Account - Integrate Search by Type API Integration - New Changes
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes.
 *
 * By            : H422335
 * On            : Oct 09, 2020
 * Description   : ASDS-3035 Migration of backend URLs to Forge endpoints
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 *
 ******************************************************************************/
import API from './api';
import { Accounts } from '../../../types/index';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import { handleResponse, handleError } from './apiUtils';
import { SaveAddressUserReqObjType } from '../utils/checkout-interfaces';
import { logError } from '../../../utils/console-utility';

class AddressDetails {

    static async getAddressDetails(userId: string, searchBy: string): Promise<Accounts> {
        const URL: string = `${CheckoutServiceURL.ADMIN_ADDRESS_DETAILS_URL}`;
        let data = await API.get(URL, { params: {'searchField': searchBy , 'search': userId}})
            .then(handleResponse)
            .catch(handleError);
        return data;
    }
    // Method to save selected address details
    static async saveSelectedAddressDetails (userId: string, userObj: SaveAddressUserReqObjType) {
        const URL: string = `${CheckoutServiceURL.SAVE_USER_ACCOUNT}/${userId}/default-addresses`;
        API.post(URL, userObj).catch(error => {
            logError('Error fetching and parsing data - save address', error);
        });
        return undefined;
    }
}
export default AddressDetails;